import axios from 'axios'

export function fetchChildCompanies(companyParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHILD_COMPANIES_FETCH',
      payload: axios(`/companies/${companyParam}/child_companies`)
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/ChildCompanyActions.js